module.exports = __webpack_public_path__ + "static/media/jobs.8ccbf668.svg";